import React, { useCallback, useEffect } from 'react';

import styled, { css } from 'styled-components';

import { getProductCtaLabel } from '~/pdp/utils/getProductCtaLabel';
import { useMysteryBoxSelectionsContext } from '~/shared/utils/mysteryBoxSelections';
import {
  Button,
  useProductDetailContext,
} from '~/techstyle-shared/react-components';
import { useIntl } from '~/techstyle-shared/react-intl';

import errorMessages from './errorMessages';
import {
  useProductDetailCTAContext,
  ProductDetailCTAErrorTypes,
} from './ProductDetailCTAContext';

const Wrapper = styled.div``;

const VIPAddToBagButton = styled(Button).attrs({
  variant: 'primaryAddToBag',
  size: 'lg',
})`
  width: 100%;

  ${({ theme }) => theme.pdpStyles.vipAddToBagButton}
`;

const labelStyle = css`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: ${-0.4 / 18}em;
  color: ${({ theme }) => theme.colors.textLight};
`;

function VIPAddToBag({ ...rest }) {
  const {
    addToCart,
    addMysteryBoxToCart,
    handleSharedValidation,
    isAssortmentTestProductDisabled,
    isForceDisableCtaEnabled,
    isLoading,
    isOutOfStock,
    onSuccessfulAddToCart,
    setErrorMessage,
    hasError,
  } = useProductDetailCTAContext();
  const intl = useIntl();
  const productDetailFromCtx = useProductDetailContext();

  const disabled =
    isLoading ||
    isOutOfStock ||
    isForceDisableCtaEnabled ||
    isAssortmentTestProductDisabled;

  const isMysteryBox = productDetailFromCtx.product?.isMysteryBundle;
  const { isSizeComplete, hasSoldOutSizeSelected } =
    useMysteryBoxSelectionsContext();
  const mysteryBoxCTADisabled =
    isLoading || !isSizeComplete || hasSoldOutSizeSelected;

  useEffect(() => {
    if (!hasError) {
      setErrorMessage(null);
    }
  }, [hasError, setErrorMessage]);

  const handleCTAClick = useCallback(async () => {
    try {
      await handleSharedValidation();
      if (isMysteryBox) {
        await addMysteryBoxToCart();
      } else {
        await addToCart();
      }
      if (onSuccessfulAddToCart) {
        onSuccessfulAddToCart();
      }
    } catch (error) {
      if (error.message === ProductDetailCTAErrorTypes.SelectorError) {
        setErrorMessage(intl.formatMessage(errorMessages.sizeSelectorError));
      }
    }
  }, [
    isMysteryBox,
    addMysteryBoxToCart,
    handleSharedValidation,
    addToCart,
    onSuccessfulAddToCart,
    setErrorMessage,
    intl,
  ]);

  return (
    <Wrapper {...rest}>
      <VIPAddToBagButton
        variant="primaryAddToBag"
        data-autotag="pdp-add-to-cart"
        data-cnstrc-btn="add-to-cart"
        labelStyle={labelStyle}
        onClick={handleCTAClick}
        disabled={isMysteryBox ? mysteryBoxCTADisabled : disabled}
      >
        {getProductCtaLabel(isAssortmentTestProductDisabled, isOutOfStock)}
      </VIPAddToBagButton>
    </Wrapper>
  );
}

export default VIPAddToBag;
